import React from "react";
import { createMarkup } from "utils/common";
import { Row, Col } from "antd";

const SMALL = { maxWidth: 576 };
const MEDIUM = { maxWidth: 768 };
const LARGE = { maxWidth: 992 };
const XLARGE = { maxWidth: 1600, minWidth: 950 };
const getSize = (size) => {
	switch (size) {
		case "small":
			return SMALL;
		case "medium":
			return MEDIUM;
		case "large":
			return LARGE;
		case "xlarge":
			return XLARGE;
		default:
			return MEDIUM;
	}
};

export const Section = ({
	id,
	title,
	description,
	footerDescription,
	children,
	size = "medium",
	style = {},
}) => {
	const sizeStyle = getSize(size);

	return (
		<div
			className="qna-section-container"
			key={id}
			style={{ ...sizeStyle, ...style }}
		>
			<div className="qna-section-questions-container">
				{title && <h3 className="qna-section-title">{title}</h3>}
				{description && (
					<p
						className="qna-section-description"
						dangerouslySetInnerHTML={createMarkup(description)}
					></p>
				)}
				{children}
				{footerDescription && (
					<p
						className="qna-section-footer-description"
						dangerouslySetInnerHTML={createMarkup(
							footerDescription
						)}
					></p>
				)}
			</div>
		</div>
	);
};

export const QuestionRow = ({
	rowClassName = "qna-question-form-item-group",
	children,
	...otherProps
}) => {
	return (
		<Row
			align="middle"
			className={"qna-question-container " + rowClassName}
			{...otherProps}
		>
			{children}
		</Row>
	);
};

export const QuestionComponent = ({
	title,
	description,
	isMandatory = false,
	rowClassName,
	inputColWidth = 24,
	labelColWidth = 24,
	depth = 0,
	children,
	question,
}) => {
	return (
		<QuestionRow rowClassName={rowClassName}>
			<QuestionLabelCol
				depth={depth}
				title={title}
				isMandatory={isMandatory}
				description={description}
				labelColWidth={labelColWidth}
				isHeading={question?.inputType === "Heading"}
			/>
			<QuestionInputCol inputColWidth={inputColWidth}>
				{children}
			</QuestionInputCol>
		</QuestionRow>
	);
};

export const QuestionLabelCol = ({
	depth,
	title,
	isMandatory,
	description,
	labelColWidth,
	className = "",
	children,
	isHeading,
	...otherProps
}) => {
	const titleMarkup = createMarkup(title);
	const Heading = ({ children }) => {
		return (
			<h3
				dangerouslySetInnerHTML={titleMarkup}
				style={{ marginBottom: 0 }}
			></h3>
		);
	};
	const Label = ({ children }) => {
		return (
			<span className={className} dangerouslySetInnerHTML={titleMarkup}>
				{children}
			</span>
		);
	};

	return (
		<Col
			span={labelColWidth}
			className={"qna-question-form-item-label " + className}
			{...otherProps}
		>
			<div className={"margin-left-" + depth}>
				{title ? (
					isHeading ? (
						<Heading />
					) : (
						<Label />
					)
				) : (
					<span className={className}>{children}</span>
				)}

				{isMandatory && <span className="text-mandatory">*</span>}
			</div>

			{description && (
				<div className={"margin-left-" + depth}>
					<span
						className="qna-question-form-item-description-label"
						dangerouslySetInnerHTML={createMarkup(description)}
					></span>
				</div>
			)}
		</Col>
	);
};

export const QuestionInputCol = ({
	inputColWidth,
	suffix,
	children,
	style,
	...otherProps
}) => {
	return (
		<Col span={inputColWidth} style={{ ...style }} {...otherProps}>
			<div className="qna-question-form-item-control">{children}</div>
			{suffix}
		</Col>
	);
};
